import { render, staticRenderFns } from "./PreOtp.vue?vue&type=template&id=2cd96c48&scoped=true&lang=pug&"
import script from "./PreOtp.vue?vue&type=script&lang=js&"
export * from "./PreOtp.vue?vue&type=script&lang=js&"
import style0 from "./PreOtp.vue?vue&type=style&index=0&id=2cd96c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd96c48",
  null
  
)

export default component.exports